export interface WorkflowStep {
  requiresQueue: boolean;
  searchQueue?: boolean | undefined;
  assetIdTemplate: string;
  dependencies: string[];
}

export interface DomainWorkflowConfig {
  requiresQueue: boolean;
  queueIdField?: 'queueId' | 'name';
  requiresBulkUpload?: boolean | undefined;
  steps: {
    types: WorkflowStep;
    reasons: WorkflowStep;
    drivers: WorkflowStep;
  };
}

export const DOMAIN_WORKFLOW_CONFIGS: Record<string, DomainWorkflowConfig> = {
  IMH: {
    requiresQueue: true,
    queueIdField: 'name',
    steps: {
      types: {
        requiresQueue: true,
        assetIdTemplate: 'type-queueName:<queueName>',
        dependencies: []
      },
      reasons: {
        requiresQueue: true,
        assetIdTemplate: 'reason-queueName:<queueName>',
        dependencies: []
      },
      drivers: {
        requiresQueue: false,
        assetIdTemplate: 'driver',
        dependencies: []
      }
    }
  },
  CTK: {
    requiresQueue: true,
    queueIdField: 'name',
    requiresBulkUpload: false,
    steps: {
      types: {
        requiresQueue: false,
        assetIdTemplate: 'Type-Country:<countryName>',
        dependencies: ['country']
      },
      reasons: {
        requiresQueue: false,
        assetIdTemplate: 'Reason_for_Contact__c-Type:<typeName>',
        dependencies: ['type']
      },
      drivers: {
        requiresQueue: false,
        searchQueue: true,
        assetIdTemplate: 'CTK_Root_Causes__c-queueName:<queueName>',
        dependencies: []
      }
    }
  },
  ATP: {
    requiresQueue: true,
    queueIdField: 'queueId',
    steps: {
      types: {
        requiresQueue: true,
        assetIdTemplate: 'type-queueId:<queueId>',
        dependencies: []
      },
      reasons: {
        requiresQueue: true,
        assetIdTemplate: 'reason-type:<typeName> <queueId>',
        dependencies: ['type']
      },
      drivers: {
        requiresQueue: true,
        assetIdTemplate: 'driver-reason:<reasonName> <queueId>',
        dependencies: ['reason']
      }
    }
  },
  BGC: {
    requiresQueue: true,
    queueIdField: 'name',
    steps: {
      types: {
        requiresQueue: true,
        assetIdTemplate: 'type-queueName:<queueName>',
        dependencies: []
      },
      reasons: {
        requiresQueue: false,
        assetIdTemplate: 'reason-type:<typeName>',
        dependencies: ['type']
      },
      drivers: {
        requiresQueue: false,
        assetIdTemplate: 'driver',
        dependencies: []
      }
    }
  },
  BXT_SE: {
    requiresQueue: true,
    queueIdField: 'name',
    steps: {
      types: {
        requiresQueue: true,
        assetIdTemplate: 'type-queueName:<queueName>',
        dependencies: []
      },
      reasons: {
        requiresQueue: true,
        assetIdTemplate: 'reasonForContact-type:<typeName> <queueName>',
        dependencies: ['type']
      },
      drivers: {
        requiresQueue: true,
        assetIdTemplate: 'contactDriver-type:<typeName> <queueName>',
        dependencies: ['type']
      }
    }
  },
  DT: {
    requiresQueue: true,
    queueIdField: 'name',
    steps: {
      types: {
        requiresQueue: true,
        assetIdTemplate: 'type-queueName:<queueName>',
        dependencies: []
      },
      reasons: {
        requiresQueue: true,
        assetIdTemplate: 'reason-queueName:<queueName>',
        dependencies: []
      },
      drivers: {
        requiresQueue: false,
        assetIdTemplate: 'driver',
        dependencies: []
      }
    }
  },
  NJS: {
    requiresQueue: false,
    steps: {
      types: {
        requiresQueue: false,
        assetIdTemplate: 'type',
        dependencies: []
      },
      reasons: {
        requiresQueue: false,
        assetIdTemplate: 'reason-type:<typeName>',
        dependencies: ['type']
      },
      drivers: {
        requiresQueue: false,
        assetIdTemplate: 'driver-type:<typeName>',
        dependencies: ['type']
      }
    }
  },
  WA: {
    requiresQueue: true,
    queueIdField: 'name',
    steps: {
      types: {
        requiresQueue: true,
        assetIdTemplate: 'type-queueName:<queueName>',
        dependencies: []
      },
      reasons: {
        requiresQueue: true,
        assetIdTemplate: 'reason-queueName:<queueName>',
        dependencies: []
      },
      drivers: {
        requiresQueue: false,
        assetIdTemplate: 'driver',
        dependencies: []
      }
    }
  },
  MHLS: {
    requiresQueue: false,
    steps: {
      types: {
        requiresQueue: false,
        assetIdTemplate: 'Type',
        dependencies: []
      },
      reasons: {
        requiresQueue: false,
        assetIdTemplate: 'Reason_for_Contact__c-Type:<typeName>',
        dependencies: ['type']
      },
      drivers: {
        requiresQueue: false,
        assetIdTemplate: 'contactDriver-Type:<typeName> <countryName>',
        dependencies: ['type']
      }
    }
  }
};

export const getDomainWorkflowConfig = (
  domainId: string
): DomainWorkflowConfig | null => {
  return DOMAIN_WORKFLOW_CONFIGS[domainId] || null;
};

export const buildAssetId = (
  template: string,
  params: {
    queueId?: string;
    queueName?: string;
    typeName?: string;
    reasonName?: string;
    countryName?: string;
  }
): string => {
  return template
    .replace('<queueId>', params.queueId || '')
    .replace('<queueName>', params.queueName || '')
    .replace('<typeName>', params.typeName || '')
    .replace('<reasonName>', params.reasonName || '')
    .replace('<countryName>', params.countryName || '');
};
